export const generateFormData = ({
  file,
  accessType = 'HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE',
  folderPath,
  fileName
}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('options', JSON.stringify({
    access: accessType
  }));
  if (folderPath) formData.append('folderPath', folderPath);
  if (fileName) formData.append('fileName', fileName);
  return formData;
};